import * as Klaro from 'klaro/dist/klaro-no-css';

const config = {
    version: 1,
    testing: false,
    elementID: 'klaro',
    styling: {
        theme: [
            'right',
            // 'light',
            // 'top',
            // 'wide'
        ],
    },
    noAutoLoad: false,
    htmlTexts: false,
    embedded: false,
    groupByPurpose: false,
    storageMethod: 'cookie',
    storageName: 'klaro',
    // cookieDomain: '.example.com',
    cookieExpiresAfterDays: 365,
    default: false,
    mustConsent: false,
    acceptAll: true,
    hideDeclineAll: false,
    hideLearnMore: false,
    noticeAsModal: false,
    disablePoweredBy: false,
    showNoticeTitle: true,
    autoFocus: true,
    // lang: 'de',

    translations: {
        // zz = default translations
        zz: {},
        en: {
            privacyPolicyUrl: '/privacy-policy',
            consentNotice: {
                title: 'Your privacy',
                changeDescription: 'There have been changes since your last visit, please update your selection.',
                description: 'Your privacy is important to us. Therefore, we do not use external services or collect personal data without your consent. Here you can agree to the use of external services (especially for displaying external content and collecting anonymized visitor statistics), reject them, or make individual settings.',
                learnMore: 'Settings',
            },
            consentModal: {
                title: 'Your privacy settings',
                description: 'Here you can view and adjust which personal data we collect and which external services we use.',
                privacyPolicy: {
                    name: 'Privacy Policy',
                    text: 'For more details, see our {privacyPolicy}.',
                }
            },
            ok: 'Agree',
            save: 'Save',
            decline: 'Decline',
            close: 'Close',
            acceptSelected: 'Save selection',
            acceptAll: 'Accept all',
            app: {
                disableAll: {
                    title: 'Toggle all applications',
                    description: 'With this button you can activate or deactivate all applications at once.',
                },
                optOut: {
                    title: '(Opt-Out)',
                    description: 'This application is loaded by default (but you can deactivate it)',
                },
                required: {
                    title: '(always required)',
                    description: 'This application is always required.',
                },
                purposes: 'Purposes',
                purpose: 'Purpose',
            },
            poweredBy: 'Powered by Klaro!',
            
            purposes: {
                general: 'Basic functionality and security',
                multimedia: 'External content',
                analytics: 'Statistics',
            },
        },
        de: {
            privacyPolicyUrl: '/datenschutz',
            consentNotice: {
                title: 'Ihre Privatsphäre',
                changeDescription: 'Es gab Änderungen seit Ihrem letzten Besuch, bitte aktualisieren Sie Ihre Auswahl.',
                description: 'Ihre Privatsphäre ist uns wichtig. Deswegen verwenden wir ohne Ihre Zustimmung keine externen Services oder erfassen persönliche Daten. Sie können dem Einsatz von externen Services (insbesondere für die Anzeige externer Inhalte und zur Erfassung anonymisierter Besucherstatistiken) hier zustimmen, diesen ablehnen oder individuelle Einstellungen treffen.',
                learnMore: 'Einstellungen',
            },
            consentModal: {
                title: 'Ihre Privatsphäre-Einstellungen',
                description: 'Hier können Sie einsehen und anpassen, welche persönlichen Daten wir erfassen und welche externen Services wir nutzen.',
                privacyPolicy: {
                    name: 'Datenschutzerklärung',
                    text: 'Weitere Details finden Sie in unserer {privacyPolicy}.',
                }
            },
            ok: 'Zustimmen',
            save: 'Speichern',
            decline: 'Ablehnen',
            close: 'Schließen',
            acceptSelected: 'Auswahl speichern',
            acceptAll: 'Allen zustimmen',
            app: {
                disableAll: {
                    title: 'Alle Anwendungen umschalten',
                    description: 'Mit dieser Schaltfläche können Sie alle Anwendungen auf einmal aktivieren bzw. deaktivieren.',
                },
                optOut: {
                    title: '(Opt-Out)',
                    description: 'Diese Anwendung wird standardmäßig geladen (Sie können sie aber deaktivieren)',
                },
                required: {
                    title: '(immer notwendig)',
                    description: 'Diese Anwendung wird immer benötigt.',
                },
                purposes: 'Verwendungszwecke',
                purpose: 'Verwendungszweck',
            },
            poweredBy: 'Umgesetzt mit Klaro!',

            purposes: {
                general: 'Basisfunktionalität und Sicherheit',
                multimedia: 'Externe Inhalte',
                analytics: 'Statistik',
            },
        },
        nl: {
            privacyPolicyUrl: '/privacy-policy',
            consentNotice: {
                title: 'Uw privacy',
                changeDescription: 'Er zijn veranderingen sinds uw laatste bezoek, gelieve uw selectie aan te passen.',
                description: 'Uw privacy is belangrijk voor ons. Daarom maken wij geen gebruik van externe diensten en verzamelen wij geen persoonsgegevens zonder uw toestemming. U kunt hier instemmen met het gebruik van externe diensten (met name voor de weergave van externe inhoud en voor het verzamelen van geanonimiseerde bezoekersstatistieken), deze afwijzen of individuele instellingen maken.',
                learnMore: 'Instellingen',
            },
            consentModal: {
                title: 'Uw privacy-instellingen',
                description: 'Hier kunt u zien en aanpassen welke persoonsgegevens wij verzamelen en welke externe diensten wij gebruiken.',
                privacyPolicy: {
                    name: 'Privacybeleid',
                    text: 'Voor meer details, zie onze {privacyPolicy}.',
                }
            },
            ok: 'Akkoord',
            save: 'Save',
            decline: 'Daling',
            close: 'Sluiten',
            acceptSelected: 'Selectie opslaan',
            acceptAll: 'Met alles eens',
            app: {
                disableAll: {
                    title: 'Schakel alle toepassingen',
                    description: 'Met deze knop kunt u alle toepassingen in één keer activeren of deactiveren.',
                },
                optOut: {
                    title: '(Opt-Out)',
                    description: 'Deze toepassing wordt standaard geladen (maar u kunt ze deactiveren)',
                },
                required: {
                    title: '(altijd nodig)',
                    description: 'Deze toepassing is altijd nodig.',
                },
                purposes: 'Doel van het gebruik',
                purpose: 'Beoogd gebruik',
            },
            poweredBy: 'Geïmplementeerd met Klaro!',

            purposes: {
                general: 'Basisfunctionaliteit en veiligheid',
                multimedia: 'Externe inhoud',
                analytics: 'Statistieken',
            },
        },
    },

    // This is a list of third-party services that Klaro will manage for you.
    services: [
        {
            name: 'klaro',
            default: true,
            required: true,
            purposes: ['general'],
            cookies: ['klaro'],
            translations: {
                de: {
                    title: 'Privatsphäre-Einstellungen',
                    description: 'In dem klaro-Cookie werden Iher hier getroffenen Privatsphäre-Einstellungen gespeichert.',
                },
                en: {
                    title: 'Privacy settings',
                    description: 'This cookie is used to save your privacy settings.',
                },
                nl: {
                    title: 'Privacy-instellingen',
                    description: 'De klaro-cookie slaat de privacyinstellingen op die u hier hebt gemaakt.',
                },
            },
        },
        {
            name: 'csrf',
            default: true,
            required: true,
            purposes: ['general'],
            cookies: ['CRAFT_CSRF_TOKEN'],
            translations: {
                de: {
                    title: 'CSRF-Schutz',
                    description: 'Verhindert gefälsche Anfragen von externen Seiten.',
                },
                en: {
                    title: 'CSRF protection',
                    description: 'Prevent forged requests from external sites.',
                },
                nl: {
                    title: 'CSRF-bescherming',
                    description: 'Voorkomt valse verzoeken van externe sites.',
                },
            },
        },
        {
            name: 'YouTube',
            purposes: ['multimedia'],
            translations: {
                de: {
                    title: 'YouTube',
                    description: 'Diese Option aktiviert eingebettete YouTube-Videos.',
                },
                en: {
                    title: 'YouTube',
                    description: 'This option activates embedded YouTube videos.',
                },
                nl: {
                    title: 'YouTube',
                    description: 'Deze optie activeert ingesloten YouTube-video\'s.',
                },
            },
        },
        {
            name: 'Vimeo',
            purposes: ['multimedia'],
            translations: {
                de: {
                    title: 'Vimeo',
                    description: 'Diese Option aktiviert eingebettete Vimeo-Videos.',
                },
                en: {
                    title: 'Vimeo',
                    description: 'This option activates embedded Vimeo videos.',
                },
                nl: {
                    title: 'Vimeo',
                    description: 'Deze optie activeert ingesloten Vimeo video\'s.',
                },
            },
        },
        {
            name: 'curator',
            purposes: ['multimedia'],
            translations: {
                de: {
                    title: 'Curator.io',
                    description: 'Diese Option aktiviert die Darstellung des Social Media Feeds über curator.io.',
                },
                en: {
                    title: 'Curator.io',
                    description: 'This option activates the social media feed using curator.io',
                },
                nl: {
                    title: 'Curator.io',
                    description: 'Deze optie activeert de sociale media feed met behulp van curator.io',
                },
            }
        },
        {
            name: 'googlemaps',
            purposes: ['multimedia'],
            translations: {
                de: {
                    title: 'Google Maps',
                    description: 'Diese Option aktiviert eingebettete Karten über Google Maps.',
                },
                en: {
                    title: 'Google Maps',
                    description: 'This option activates embedded maps using Google Maps.',
                },
                nl: {
                    title: 'Google Maps',
                    description: 'Deze optie activeert ingebedde kaarten met Google Maps.',
                },
            }
        },
        {
            name: 'matomo',
            default: true,
            optOut: true,
            onlyOnce: true,
            purposes: ['analytics'],
            cookies: [
                /^_pk_.*$/,
            ],
            translations: {
                de: {
                    title: 'Matomo',
                    description: 'Wir verwenden die Open-Source-Software Matomo, um anonyme Besucherstatistiken zu sammeln. Hierbei werden keine privaten Daten erfasst.',
                },
                en: {
                    title: 'Matomo',
                    description: 'We use the open source software Matomo to collect visitor statistics. This doesn’t collect any personal data.',
                },
                nl: {
                    title: 'Matomo',
                    description: 'Wij gebruiken de open source software Matomo om anonieme bezoekersstatistieken te verzamelen. In dit proces worden geen privégegevens verzameld.',
                },
            },
        },
    ],
};

// Initialize klaro with the given config.
Klaro.setup(config);

// Provide global access to the klaro instance and its config.
window.klaro = Klaro;
window.klaroConfig = config;

// Provide a utility class for links to open the klaro modal.
const managePrivacyPreferencesLinks = Array.from(document.querySelectorAll('.klaro-show'));
managePrivacyPreferencesLinks.forEach(link => link.addEventListener('click', e => {
    e.preventDefault();
    window.klaro.show();
}));
